import { ApplicationSetting } from '@era/settings-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import type { CategoryType } from '@rocksoft/shared';

export interface CategoryApplicationSetting extends ApplicationSetting {
  categoryType: CategoryType;
  categoryId: string;
  bundleIdentifier: string;
}

export function selectSettingIdFromSetting(setting: CategoryApplicationSetting) {
  const key: string = [setting.categoryType, setting.categoryId, setting.bundleIdentifier, setting.key].join('');
  return key;
}

export const adapter: EntityAdapter<CategoryApplicationSetting> = createEntityAdapter<CategoryApplicationSetting>({
  selectId: selectSettingIdFromSetting,
});

export type CategoryApplicationSettingState = EntityState<CategoryApplicationSetting>;

export const initialState: CategoryApplicationSettingState = adapter.getInitialState();
